module.exports = __webpack_public_path__ + "media/images/Flame-and-Glow-4a359c2dc2359e1aab8477a0d423e8ea.png";